export const API_STALE_TIME_MS = 60_000;
export const DRILL_TIME_LIMIT_SECONDS = 15;